import { Link, NavLink } from 'react-router-dom';

import { useAdminAuth } from '../auth/AuthProvider';

export function Nav() {
  const auth = useAdminAuth();
  return (
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 p-4">
        <Link to="/" className="text-lg font-semibold text-brand">
          Signatory Admin
        </Link>
        <nav className="flex items-center gap-4 text-sm">
          <NavLink to="/tenants" className={({ isActive }) => (isActive ? 'font-semibold' : '')}>
            Tenants
          </NavLink>
          <NavLink to="/contracts" className={({ isActive }) => (isActive ? 'font-semibold' : '')}>
            Contracts
          </NavLink>
          <NavLink to="/health/webhooks" className={({ isActive }) => (isActive ? 'font-semibold' : '')}>
            Webhooks
          </NavLink>
          <NavLink to="/health/system" className={({ isActive }) => (isActive ? 'font-semibold' : '')}>
            System
          </NavLink>
        </nav>
        <div className="flex items-center gap-3 text-sm">
          <span className="text-slate-600">{auth.email}</span>
          <button type="button" className="btn" onClick={auth.logout}>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}
